import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Clock, ChevronRight, Package } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const statusConfig = {
  'Reçue': { color: 'bg-orange-500', text: 'Commande reçue', icon: '📦' },
  'En préparation': { color: 'bg-blue-500', text: 'En préparation', icon: '👨‍🍳' },
  'Prête': { color: 'bg-emerald-500', text: 'Prête à récupérer !', icon: '✅' },
};

export function ActiveOrderBanner() {
  const { token, user, isAuthenticated } = useAuth();
  const [activeOrder, setActiveOrder] = useState(null);

  const fetchActiveOrder = useCallback(async () => {
    if (!token || !user || user.role !== 'Client') return;

    try {
      const response = await axios.get(`${API}/orders`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Find the most recent active order (not completed or cancelled)
      const active = response.data.find(order => 
        ['Reçue', 'En préparation', 'Prête'].includes(order.status)
      );
      
      setActiveOrder(active || null);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  }, [token, user]);

  useEffect(() => {
    fetchActiveOrder();
    // Poll every 30 seconds
    const interval = setInterval(fetchActiveOrder, 30000);
    return () => clearInterval(interval);
  }, [fetchActiveOrder]);

  if (!isAuthenticated || !activeOrder || user?.role !== 'Client') {
    return null;
  }

  const config = statusConfig[activeOrder.status] || statusConfig['Reçue'];

  return (
    <Link 
      to={`/commandes/${activeOrder.id}`}
      className={`block ${config.color} text-white`}
    >
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-2xl">{config.icon}</span>
            <div>
              <p className="font-medium">{config.text}</p>
              <p className="text-sm text-white/80">
                {activeOrder.restaurant_name} • {activeOrder.order_number}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="hidden sm:flex items-center gap-1 text-sm text-white/80">
              <Clock className="w-4 h-4" />
              Retrait à {new Date(activeOrder.pickup_slot).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
            </div>
            <div className="flex items-center gap-1 font-medium">
              Suivre
              <ChevronRight className="w-5 h-5" />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
